import { render, staticRenderFns } from "./SupplierNotice.vue?vue&type=template&id=4458ded0&scoped=true&"
import script from "./SupplierNotice.vue?vue&type=script&lang=js&"
export * from "./SupplierNotice.vue?vue&type=script&lang=js&"
import style0 from "./SupplierNotice.vue?vue&type=style&index=0&id=4458ded0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4458ded0",
  null
  
)

export default component.exports